export default{
    MINI_CHART_DATA:"MINI_CHART_DATA"
}